import { z } from "zod";
import { BLOCK_NAME, COMMUNITY_ID, DESCRIPTION, ZONE_ID, LIST, NEW, DELETED, BLOCK_ID } from "./consts";

export const addSchema = z.object({
  [COMMUNITY_ID]: z.string().min(1, "This field is required"),
  [ZONE_ID]: z.string().min(1, "This field is required"),
  [LIST]: z.array(z.object({
    [BLOCK_ID]: z.string().optional(),
    [BLOCK_NAME]: z.string().min(1, "This field is required"),
    [DESCRIPTION]: z.string().optional(),
    [NEW]: z.boolean().optional(),
    [DELETED]: z.boolean().optional(),
  })).min(1, "At least one zone is required")
});

export type AddBlockFormValues = z.infer<typeof addSchema>;
